import { Flex as ChakraFlex, FlexProps, forwardRef } from '@chakra-ui/react';
/**
 * Flex is Box with display set to flex and comes with helpful style shorthand. It renders a `div` element.
 */
export const Flex = forwardRef((props: FlexProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraFlex ref={ref} {...otherProps}>
      {children}
    </ChakraFlex>
  );
});

export { Spacer } from '@chakra-ui/react';
